import { ChevronDown16 } from '@yunex/yds-icons';
import { rem } from '../../../utils/rem';
export var MuiSelect = {
    defaultProps: { IconComponent: ChevronDown16, variant: 'outlined' },
    styleOverrides: {
        root: {
            paddingBottom: rem(6.7),
            paddingTop: rem(6.7),
        },
        select: {
            paddingInline: rem(14),
            paddingBlock: rem(5.5),
            '&:focus': {
                backgroundColor: 'transparent',
            },
        },
        iconOutlined: {
            top: rem(7),
        },
    },
};
